import React, { useCallback, useContext } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";
import { AppContext } from "../../../lib/Context";

export default function SecondStep({ courseDetails }) {
  const { formValues, handleChange, handleBack, handleNext, variant, margin } =
    useContext(AppContext);
  const { transactionID, agreenemt } = formValues;

  const isError = useCallback(
    () =>
      Object?.keys({ transactionID, agreenemt })?.some(
        (name) =>
          (formValues[name]?.required && !formValues[name]?.value) ||
          formValues[name]?.error
      ),
    [formValues, transactionID, agreenemt]
  );

  return (
    <>
      <ul>
        <li className="border-b-[2px] py-4 flex justify-between items-center border-[#efefff]">
          <span>
            <strong className=" text-xs max-sm:text-base font-medium ml-1 font-fira text-[#212832]">
              {courseDetails?.title}
            </strong>
          </span>
          <h6 className=" max-sm:text-base text-sm text-[#52565b] font-bold">
            {" "}
            ৳ {courseDetails?.price?.originalPrice}
          </h6>
        </li>
        <li className="border-b-[2px] py-4  border-[#efefff]">
          <span>
            <strong className=" text-xs max-sm:text-base font-medium ml-1 font-fira text-[#212832]">
              বিকাশ, নগদ এবং রকেট মাধ্যমে send money করতে পারেন! (01617412827)
              (নগদ No. 01860974587) এই নাম্বারে পেমেন্ট করে আপনার Transaction Id
              টা দিন।
            </strong>
          </span>
        </li>
      </ul>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            variant={variant}
            margin={margin}
            fullWidth
            label="Transaction ID"
            name="transactionID"
            placeholder="Enter your transaction ID"
            value={transactionID.value}
            onChange={handleChange}
            error={!!transactionID.error}
            helperText={transactionID.error}
            required={transactionID.required}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreenemt?.value}
                onChange={handleChange}
                name="agreenemt"
                color="primary"
                required={agreenemt?.required}
              />
            }
            label="Agree to terms and conditions"
          />
          <FormHelperText error={!!agreenemt?.error}>
            {agreenemt?.error}
          </FormHelperText>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Button
          variant="contained"
          disabled={isError()}
          color="primary"
          onClick={!isError() ? handleNext : () => null}
        >
          Next
        </Button>
      </Box>
    </>
  );
}
